module.exports = __webpack_public_path__ + "img/page-desc-para.9845bd65.png";